import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isDrawerOpen: false,
};

const drawerSlice = createSlice({
    name: 'drawer',
    initialState,
    reducers: {
        openDrawer: (state) => {
            state.isDrawerOpen = true;
        },
        closeDrawer: (state) => {
            state.isDrawerOpen = false;
        },
    },
});

export const { openDrawer, closeDrawer } = drawerSlice.actions;
export const drawerReducer = drawerSlice.reducer;